<script setup lang="ts">

</script>

<template>

    <div class="max-w-5xl mx-auto px-8">
        <div class="tracking-wider pt-48 pb-16 lg:-mx-5 xl:-mx-16">
            <div class="rounded-3xl bg-gray-50 pr-4">

                <div class="flex justify-center z-10">
                    <video ref="video"
                           width="80%" 
                           autoplay 
                           controls 
                           class="-mt-56 mb-8 rounded-lg shadow-lg ring ring-black"
                           onloadstart="this.volume=0.3">
                        <source src="@/assets/video/rewards.mp4" type="video/mp4" />
                        <!-- <img src="@/assets/images/Screenshots/screenshot-app-hero-angled.png" class="w-2/3 md:w-1/2 -mt-64 scale-90"/> -->
                    </video> 
                </div>
                
                <div class="grid grid-cols-1 md:grid-cols-3 pb-6">

                    <!-- SAVE -->
                    <div class="flex flex-col items-center p-6 md:p-8 lg:p-12">
                        <h2 class="text-2xl font-semibold my-4 text-center">
                            It's like air-miles for your car
                        </h2>    
                        <p class="text-center">
                            You get rewarded when you service your car or purchase from
                            one of our 1,500+ lifestyle partners
                        </p>                              
                    </div>

                    <!-- SPEND -->
                    <div class="flex flex-col items-center p-6 md:p-8 lg:p-12">
                        <h2 class="text-2xl font-semibold my-4 text-center">
                            Real money, not points
                        </h2>    
                        <p class="text-center">
                            Your rewards are provided back to you as real cash!
                        </p>                
                        <p class="text-center mt-2">
                            So transfer the cash back into your bank account whenever you need it.
                        </p> 
                    </div>

                    <!-- DONATE -->
                    <div class="flex flex-col items-center p-6 md:p-8 lg:p-12">
                        <h2 class="text-2xl font-semibold my-4 text-center">
                            Your money, your way
                        </h2>    
                        <p class="text-center">
                            Use the cashback to reward yourself, or save it to cover those big car expenses.
                        </p>                
                        <p class="text-center mt-2">
                            Reduces the cost and hassle of keeping your car in good shape
                        </p> 
                    </div>
                    
                </div>

            </div>

        </div>
    </div>

</template>